<app-popup-header>
    <app-popup-header-title title="{{header}}" ></app-popup-header-title>
    <p *ngIf="description" class="mm-popup-wizard-header-description">{{description}}</p>
    <ng-content></ng-content>
</app-popup-header>
